import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExcelIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 6.25,
			y: 1.5625,
			width: 18.75,
			height: 21.875,
			rx: 2,
			fill: "#2FB776"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 17.9688H25V21.4375C25 22.5421 24.1046 23.4375 23 23.4375H8.25C7.14543 23.4375 6.25 22.5421 6.25 21.4375V17.9688Z",
			fill: "url(#paint0_linear_5878_216766)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.625,
			y: 12.5,
			width: 9.375,
			height: 5.46875,
			fill: "#229C5B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 15.625,
			y: 7.03125,
			width: 9.375,
			height: 5.46875,
			fill: "#27AE68"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 3.5625C6.25 2.45793 7.14543 1.5625 8.25 1.5625H15.625V7.03125H6.25V3.5625Z",
			fill: "#1D854F"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.25,
			y: 7.03125,
			width: 9.375,
			height: 5.46875,
			fill: "#197B43"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.25,
			y: 12.5,
			width: 9.375,
			height: 5.46875,
			fill: "#1B5B38"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 10.0312C6.25 8.3744 7.59315 7.03125 9.25 7.03125H12.625C14.2819 7.03125 15.625 8.3744 15.625 10.0312V18.0938C15.625 19.7506 14.2819 21.0938 12.625 21.0938H6.25V10.0312Z",
			fill: "black",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 5.46875,
			width: 14.0625,
			height: 14.0625,
			rx: 2,
			fill: "url(#paint1_linear_5878_216766)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1562 16.4062L7.95479 12.4219L10.0596 8.59375H8.34139L7.04199 11.0379L5.76407 8.59375H3.99216L6.10771 12.4219L3.90625 16.4062H5.62446L7.00977 13.817L8.38434 16.4062H10.1562Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_5878_216766",
			x1: 6.25,
			y1: 20.7031,
			x2: 25,
			y2: 20.7031,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#163C27" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#2A6043"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_5878_216766",
			x1: 0,
			y1: 12.5,
			x2: 14.0625,
			y2: 12.5,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#185A30" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#176F3D"
			})]
		})] })
	]
});
export default SvgExcelIcon;
